import http from './http';
import { MeasurementUnit } from '@monolith/legacy/types/product-shape';

export const getMeasurementUnits = async (): Promise<MeasurementUnit[]> =>
  http()
    .get('/api/measurement_units')
    .then((response) => response.data.data);
